import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Site } from '../../models/sites.model';

import { Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
// import { UserSiteConfirmationDialogueComponent } from '../user-site-confirmation-dialogue/user-site-confirmation-dialogue.component';
import { AdmirCommonService } from 'src/app/services/admir-common.service';
import { SitesService } from '../sites.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Application } from '../../models/application.model';
import { ApplicationsService } from '../../applications/applications.service';


@Component({
  selector: 'app-sites-mat-table-maint',
  templateUrl: './sites-mat-table-maint.component.html',
  styleUrls: ['./sites-mat-table-maint.component.scss']
})
export class SitesMatTableMaintComponent implements OnInit {
  displayedColumns: string[] = ['siteName', 'dogF', 'city', 'region', 'distance', 'postalCode']; // , 'siteName2', 'postalCode'
  dataSourceSites: MatTableDataSource<Site>;
  @Input() companyId: string;
  @Input() siteId: string;
  @Input() itemsPerPage = 3;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Output() SitesReadyCompleteEvent: EventEmitter<any> = new EventEmitter();
  @Output() UserSiteConfirmationCompleteEvent: EventEmitter<any> = new EventEmitter();

  sites$: Observable<Site[]>;
  step = 0;
  applicationForm: UntypedFormGroup;
  applications$: Observable<Application[]>;
  public statuses: any = ['prod', 'dev', 'test', 'dummy'];

  constructor(
    private router: Router,
    private sitesService: SitesService,
    public dialog: MatDialog,
    private admirCommonService: AdmirCommonService,
    public fb: UntypedFormBuilder,
    private applicationsService: ApplicationsService,
  ) {


  }

  showId(value: any) {
    return value.id;
  }

  showStatus(value: any) {
    return value.status;
  }

  ngOnInit(): void {

    this.applicationForm = this.fb.group({
      id: [''],
      status: [''],
      name: ['']

    });

    this.applications$ = this.applicationsService.findApplications();

    // if (this.siteId?.length > 0 && this.companyId?.length > 0) {
    //   this.sitesService.getSitesByCompanyIdSiteId(this.companyId, this.siteId);

    // } else {
    //   this.sitesService.getSitesByCompanyId(this.companyId);
    // }


    // this.sitesService.getSitesByCompanyId(this.companyId);

  }

  public setLocation(e: any, maxSites?: any) {

    const lat = e.coords.latitude;
    const lon = e.coords.longitude;

    this.sites$ = this.loadSites(lat, lon, maxSites);

    this.sites$.subscribe((sites: Site[]) => {

      if (sites.length === 0) { return; }

      // let newSites = []

      // sites.forEach((site: Site) => {
      //   const distance = this.admirCommonService.getDistanceFromLatLon(lat, lon, site.lat, site.lon, 'M').toFixed(1)
      //   site = Object.assign({}, site, { distance });
      //   newSites.push(site)
      // })


      // const sortedSitesByDistance = newSites.sort((a, b) => {
      //   return a.distance <= b.distance ? -1 : 1;
      // });

      // console.log("distance from home newSites", newSites)
      // console.log("distance from home newSites", sortedSitesByDistance);



      // // console.log("distance from home newSites", newSites)
      // // console.log("distance from home newSites", sortedSitesByDistance);
      // const maxSitesToShow = [];

      // sortedSitesByDistance.forEach((site,i) => {
      //   if (i<=10){
      //     maxSitesToShow.push(site)
      //   }

      // })

      // console.log("maxSitesToShowmaxSitesToShowmaxSitesToShow", maxSitesToShow);

      // var sortedSitesByDistanceTopMaxSites = (maxSites !== null) ? sortedSitesByDistance.slice(0, maxSites) : sortedSitesByDistance;


      this.dataSourceSites = new MatTableDataSource(sites);
      this.dataSourceSites.sort = this.sort;
      this.dataSourceSites.paginator = this.paginator;

      // Emit the sites here
      // const o = Object.assign({}, { time: null, sites: null });
      // o.time = new Date();
      // o.sites = sites;
      // this.SitesReadyCompleteEvent.emit(o);

    });
  }

  applyFilter(filterValue: any) {
    console.log('filterValue', filterValue);
    this.dataSourceSites.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceSites.paginator) {
      this.dataSourceSites.paginator.firstPage();
    }
  }

  loadSites(lat: any, lon: any, maxSites: any) {

    return this.sitesService.findSitesByCompanyId(this.companyId).pipe(

      map((sites) => {

        // take original sites and add distance using spread operator
        const newSites = [...sites.map((site: Site) => {
          const distance = Number(this.admirCommonService.getDistanceFromLatLon(lat, lon, site.lat, site.lon, 'M').toFixed(1));
          const newSite = Object.assign({}, site, { distance });
          return newSite;
        })];

        const sortedSitesByDistance = newSites.sort((a: any, b: any) => {
          return a.distance > b.distance ? 1 : -1;
        });

        const sortedSitesByDistanceTopMaxSites = (maxSites !== undefined) ? sortedSitesByDistance.slice(0, maxSites) : sortedSitesByDistance;
        return sortedSitesByDistanceTopMaxSites;

      }),

      catchError(() => of([])),
      finalize(() => { })
    );
  }

  matTableChange(e: any) {

  }

  launchTables(row: any) {

    // // Now update store with selected site
    // this.companySiteToStoreService.addCompanySiteUserLocation(row.companyId, row.id);
    // this.router.navigate(['/tables']);


  }

  launchBookings(row: any) {

    // Now update store with selected site
    // this.companySiteToStoreService.addCompanySiteUserLocation(row.companyId, row.id);
    // this.router.navigate(['/bookings/bookings']);


  }

  launchCategories(row: any) {
    // this.companySiteToStoreService.addCompanySiteUserLocation(row.companyId, row.id);
    // this.router.navigate(['/categories']);


  }

  launchDetails(site: any) {

    // this.companySiteToStoreService.addCompanySiteUserLocation(site.companyId, site.id);
    // window.localStorage.setItem('companyId', site.companyId);
    // window.localStorage.setItem('siteId', site.id);
    // this.router.navigate(['/site-details']);
  }

  areYouHear(e: any) {

    // popup message are you here
    this.openUserSiteConfirmationDialog(e);

  }

  openUserSiteConfirmationDialog(e: any) {

    const o = Object.assign({});
    o.companyId = this.companyId;
    const zerofilledSiteId = ('0000000' + e.id).slice(-7);
    o.siteId = zerofilledSiteId;
    o.time = new Date();

    this.UserSiteConfirmationCompleteEvent.emit(o);

    // const dialogRef = this.dialog.open(UserSiteConfirmationDialogueComponent, {
    //   width: 'auto',
    //   height: 'auto',
    //   data: {
    //     address: e.address,
    //     city: e.city,
    //     country: e.country,
    //     region: e.region,
    //     siteName: e.siteName,
    //     companyId: this.companyId,
    //     siteId: e.id
    //   }

    // });

    // dialogRef.afterClosed().subscribe(result => {

    //   if (result !== undefined) {

    //     const o = Object.assign({}, { time: null, data: null });
    //     o.time = new Date();
    //     o.data = result;
    //     this.UserSiteConfirmationCompleteEvent.emit(o);

    //   }


    // });
  }

  setStep(index: number, company: Site) {
    this.step = index;

  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  onApplicationChange(e: any) {

    alert('hi' + e);
  }

}
